import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { siteNav } from "@/mocks/site";

export default function SiteHeader() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const isHome = location.pathname === "/";
  const solid = scrolled || !isHome || menuOpen;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const logoInner = (
    <span className="flex items-center gap-2.5">
      <span
        className={`flex h-9 w-9 items-center justify-center rounded-md font-heading text-lg font-bold leading-none transition-colors ${
          solid ? "bg-primary-500 text-background-50" : "bg-background-50 text-primary-600"
        }`}
      >
        瓜
      </span>
      <span className="flex flex-col leading-none">
        <span className="font-heading text-lg font-bold tracking-tight">
          诱惑吃瓜
        </span>
        <span
          className={`mt-0.5 text-[11px] font-normal tracking-wide ${
            solid ? "text-foreground-500" : "text-background-200"
          }`}
        >
          实锤 · 反转 · 全复盘
        </span>
      </span>
    </span>
  );

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        solid
          ? "border-b border-background-200 bg-background-50/95 backdrop-blur"
          : "border-b border-transparent bg-transparent"
      }`}
    >
      <div className="flex w-full items-center justify-between gap-4 px-4 py-3 md:px-8 lg:px-12">
        {isHome ? (
          <h1 className="shrink-0">
            <Link
              to="/"
              className={`flex cursor-pointer items-center transition-colors ${
                solid ? "text-foreground-950" : "text-background-50"
              }`}
              aria-label="诱惑吃瓜首页"
            >
              {logoInner}
            </Link>
          </h1>
        ) : (
          <Link
            to="/"
            className={`flex shrink-0 cursor-pointer items-center transition-colors ${
              solid ? "text-foreground-950" : "text-background-50"
            }`}
            aria-label="返回诱惑吃瓜首页"
          >
            {logoInner}
          </Link>
        )}

        <nav aria-label="主导航" className="hidden md:block">
          <ul className="flex items-center gap-1">
            {siteNav.map((item) => (
              <li key={item.path}>
                <NavLink
                  to={item.path}
                  className={({ isActive }) =>
                    `block cursor-pointer whitespace-nowrap rounded-md px-3.5 py-2 text-sm font-medium transition-colors ${
                      isActive
                        ? solid
                          ? "bg-primary-100 text-primary-700"
                          : "bg-background-50/20 text-background-50"
                        : solid
                          ? "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                          : "text-background-200 hover:bg-background-50/15 hover:text-background-50"
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/topics"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-block"
          >
            看今日热榜
          </Link>
          <button
            type="button"
            onClick={() => setMenuOpen((prev) => !prev)}
            aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
            aria-expanded={menuOpen}
            className={`flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border text-lg transition-colors md:hidden ${
              solid
                ? "border-background-300 text-foreground-900 hover:bg-background-100"
                : "border-background-50/40 text-background-50 hover:bg-background-50/15"
            }`}
          >
            <i className={menuOpen ? "ri-close-line" : "ri-menu-line"} aria-hidden="true"></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <nav
          aria-label="移动端导航"
          className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 md:hidden"
        >
          <ul className="flex flex-col">
            {siteNav.map((item) => (
              <li key={item.path}>
                <NavLink
                  to={item.path}
                  className={({ isActive }) =>
                    `block cursor-pointer rounded-md px-3 py-3 text-sm font-medium transition-colors ${
                      isActive
                        ? "bg-primary-100 text-primary-700"
                        : "text-foreground-700 hover:bg-background-100"
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>
          <Link
            to="/topics"
            className="mt-2 block whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-center text-sm font-medium text-background-50"
          >
            看今日热榜
          </Link>
        </nav>
      )}
    </header>
  );
}